import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { useApp } from "../context/AppContext";
import Seo from "../components/Seo";

export default function NotFoundPage() {
  const { t } = useApp();
  return (
    <main className="verify-page" data-testid="not-found-page">
      <Seo title={t("title.notfound")} description={t("meta.desc")} noindex />
      <div className="verify-card verify-center">
        <div className="v-seal-icon v-seal-invalid">
          <Compass size={30} />
        </div>
        <h1 className="v-title" data-testid="notfound-title">404 — {t("nf.title")}</h1>
        <p className="v-sub">{t("nf.desc")}</p>
        <Link to="/" className="btn-lux-gold" data-testid="notfound-home-link">
          {t("nf.home")}
        </Link>
      </div>
    </main>
  );
}
